import React, { useState } from "react";

import PersonalPhoto from "../components/PersonalPhoto.js";
import CardAboutMe from "../components/CardAboutMe.js";
import Statistics from "../components/Statistics.js";
import LaborStatistics from "../components/LaborStatistics.js";
import CardCertifications from "../components/CardCertifications.js";
import Universities from "../components/Universities.js";
import Jobs from "../components/Jobs.js";
import Proyects from "../components/Proyects.js";
import ContactInformation from "../views/ContactInformation.js";


import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Fab from "@mui/material/Fab";
import SchoolIcon from "@mui/icons-material/School";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import SendIcon from "@mui/icons-material/Send";

const styleTabIcon = {
  color: "white",
  "&.Mui-selected": {
    color: "#ffc107",
  },
};

const MainModulo = () => {
  return (
    <>
      {/* Acerca de mi */}
      <div id="about-me">
        <CardAboutMe />
      </div>

      {/* estadisticas laborales */}
      <div id="labor-stats">
        <LaborStatistics />
      </div>

      {/* Formacion Academica */}
      <div id="universities">
        <Universities />
      </div>

      {/* Trabajos desempeñados */}
      <div id="jobs">
        <Jobs />
      </div>

      {/* Certificaciones */}
      <div id="certifications">
        <CardCertifications />
      </div>

      {/* Proyectos y publicaciones */}
      <div id="proyects">
        <Proyects />
      </div>
    </>
  );
};

function Desktop() {
  const [seccion, setSeccion] = React.useState(0);
 
  //redireccion a cada modulo del sistema
  const handleNavigation = (newValue) => {
    setSeccion(newValue);
    const sectionIds = [
      "universities",
      "jobs",
      "certifications",
      "proyects",
      "contact",
    ];
    const targetId = sectionIds[newValue];
    const targetElement = document.getElementById(targetId);
    if (targetElement)
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  //posicion top del scroll
  const backToHome = () => {
    const targetElement = document.getElementById("about-me");
    if (targetElement)
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="w-full min-h-screen overflow-y-auto bg-negro">

      <div className="grid grid-cols-[25%_73%] gap-4">
        {/* P r i m e r a     S e c c i o n */}
        <div className="p-4">
          {/* foto - nombre */}
          <PersonalPhoto />

          {/* Estadisticas de conocimiento */}
          <div className="flex flex-col w-full h-[calc(92vh-200px)] bg-negro_alt shadow-lg overflow-y-auto custom-scrollbar ">
            <Statistics />
          </div>
        </div>

        {/* S e g u n d a     S e c c i o n */}
        <div>
          {/* Menu */}
          <div className="w-[98%] ml-1 p-1 rounded-lg shadow-2xl bg-gris_alt transform translate-y-1 mb-4 mt-4">
            <Box sx={{ width: "90%" }}>
              <BottomNavigation
                showLabels
                value={seccion}
                onChange={(event, newValue) => handleNavigation(newValue)}
                sx={{ backgroundColor: "transparent" }}
              >
                <BottomNavigationAction
                  label="Académico"
                  icon={<SchoolIcon />}
                  sx={styleTabIcon}
                />
                <BottomNavigationAction
                  label="Laboral"
                  icon={<BusinessCenterIcon />}
                  sx={styleTabIcon}
                />
                <BottomNavigationAction
                  label="Certificaciones"
                  icon={<WorkspacePremiumIcon />}
                  sx={styleTabIcon}
                />
                <BottomNavigationAction
                  label="Proyectos"
                  icon={<IntegrationInstructionsIcon />}
                  sx={styleTabIcon}
                />
                <BottomNavigationAction
                  label="Contactame"
                  icon={<SendIcon />}
                  sx={styleTabIcon}
                />
              </BottomNavigation>
            </Box>
          </div>

          {/* Contenido */}
          <div className={`p-5 flex-col  ${seccion <4 ? "h-[calc(80vh-10px)]" : "h-auto" }  overflow-y-auto custom-scrollbar`}>
            {seccion < 4 ? <MainModulo /> : <ContactInformation />}
          </div>
        </div>
      </div>

      {/* Go To Home */}
      {seccion <4 && 
        <div className="ml-[94%] mt-[-4%]">
          <Fab
            onClick={backToHome}
            aria-label="up"
            sx={{ background: "#ffc107" }}
            size="medium"
          >
            <KeyboardArrowUpIcon sx={{ fontSize: 28 }} />
          </Fab>
        </div>
      }
    </div>
  );
}

export default Desktop;
